var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column align-items-center"},[_c('personal-signatory',{staticStyle:{"width":"40em"},model:{value:(_vm.user.signer),callback:function ($$v) {_vm.$set(_vm.user, "signer", $$v)},expression:"user.signer"}}),_vm._v(" "),_c('btn-action',{staticClass:"btn btn-primary",on:{"click":_vm.save}},[_vm._v("Сохранить")])],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bf41d17c","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/pages/personal/signatory.vue
// module id = null
// module chunks = 